// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  XORKey: "666666",
  secretkey: "39e760479d69f61ada2f598007cab3aa",
  // ApiUrl :"http://localhost:50513/api/",
  // ApiUrl :"http://10.3.252.93/VisitingCardAPI/api/",
  ApiUrl: "https://visitingcards.mykotaklife.com/VisitingCardAPI/api/",
  No_Card: 100
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
